import * as React from "react";
import { TableBody, TableCell, TableHead, TableRow, Stack, Typography, Pagination, Box, MenuItem, IconButton, useTheme } from "@mui/material";
import SearchTxtField from "../../../components/SearchTxtField";
import route from "../../../utils/Routes";
import { useNavigate, useSearchParams } from "react-router-dom";
import StyledTableContainer from "../../../components/StyledTableContainer";
import { useState } from "react";
import { formatDateWithJs, formatUserType, getPoStatusClrSx, NumberFormatter } from "../../../utils/format";
import { useAuthContext } from "../../../context/AuthContext";
import { useQuery } from "react-query";
import QueryKey from "../../../utils/QueryKey";
import { useEffect } from "react";
import { customAlert } from "../../../components/notify";
import { getPoByStoreServ } from "../../../services/po-service";
import DDMenu from "../../../components/DDMenu";
import { ArrowDropDown } from "@mui/icons-material";
import { FaSortAmountDown, FaSortAmountUpAlt } from "react-icons/fa";



const statusArr = [
    { value: "confirmed", label: "Confirmed" },
    { value: "partially_dispatched", label: "Partially Dispatched" },
    { value: "order_completed", label: "Order Completed" }
];

function StorePoListPage() {
    const theme = useTheme();
    const navigate = useNavigate();
    const { setLoadingScreen, ctxtUser } = useAuthContext();
    const limit = 9;
    const [searchParams, setSearchParams] = useSearchParams();
    const pgNo = parseInt(searchParams.get("pgNo") || "1");
    const querySearchWord = searchParams.get("s") || "";
    const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
    const [isSrchBtnClick, setIsSrchBtnClick] = useState(0);
    const userId = ctxtUser?.userId;
    const userType = ctxtUser?.userType;
    const selStatus = searchParams.get("status") || "";
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const sort = searchParams.get("sort") || "DESC";

    const { isLoading, isError, error, data: reqData } = useQuery([QueryKey.poList, pgNo, isSrchBtnClick, userId, userType, selStatus, sort],
        () => getPoByStoreServ({ limit, pageNumber: pgNo, searchWord, status: selStatus, sort }), {
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });


    const columns = [
        {
            id: 'poIdStrg',
            label: "Order Request ID",
            align: 'left',
            minWidth: 150
        },
        {
            id: 'actPoNum',
            label: "PO Number",
            align: 'left',
            minWidth: 150
        },
        {
            id: 'comName',
            label: "Company",
            align: 'left',
            minWidth: 150
        },
        {
            id: 'actProjIdStrg',
            label: "Project ID",
            align: 'left',
            minWidth: 150
        },
        {
            id: 'orderCfmTime',
            label: "OR Confirm Date",
            align: 'left',
            minWidth: 150
        },
        {
            id: 'doCount',
            label: "No of DO",
            align: 'left',
            minWidth: 150
        },
        {
            id: 'totalQty',
            label: "Total Qty",
            align: 'left',
            minWidth: 150
        },
        {
            id: 'poStatus',
            label: "OR Status",
            align: 'center',
            minWidth: 150
        }
    ];


    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    async function onSearchBtnClick(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            return prev
        }, { replace: true })
    }

    function onSearch(e) {
        setSearchWord(e.target.value)
        setSearchParams(prev => {
            prev.set("s", encodeURIComponent(e.target.value))
            return prev
        }, { replace: true })
    }

    function handleOnClear(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchWord("");
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            prev.set("s", "")
            return prev
        }, { replace: true })
    }

    const handleRowClick = (poIdStrg) => {
        navigate(`${route.aStorePoInfo}/?poId=${poIdStrg}`);
    };

    const handlePageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("pgNo", value)
            return prev
        }, { replace: true })
    };

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const handleStatusSelect = (status) => {
        //  setSelUserType(role); // Update the selected status
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            prev.set("status", status)
            return prev
        }, { replace: true })
        handleMenuClose();
    };

    function handleSortClick() {
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            prev.set("sort", sort === 'DESC' ? "ASC" : "DESC")
            return prev
        }, { replace: true })
    }

    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }


    return (
        <Box height={"100%"} width={"100%"} px={2}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1, mt: 1, pl: 1, pr: 3 }} width={"100%"}>
                <Stack width={"33%"} >
                    <Typography sx={{ fontSize: 18, fontWeight: 500, }}>Order Request List</Typography>
                </Stack>
                <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2} width={"33%"} >
                    <SearchTxtField handleOnClear={handleOnClear} searchKeyWord={searchWord} onSearch={onSearch} onBtnClick={onSearchBtnClick}
                        placeholder={"Search OR By Id / PO Number / Company..."} />
                </Stack>
                <Stack direction={"row"} justifyContent="end" alignItems={"center"} gap={2} width={"33%"} >
                    <IconButton onClick={handleSortClick} >
                        {sort === 'DESC' ? <FaSortAmountDown size={18} color={theme.palette.custom.btn} /> : <FaSortAmountUpAlt size={18} color={theme.palette.custom.btn} />}
                    </IconButton>
                </Stack>
            </Stack>

            {reqData && <StyledTableContainer height={"83%"} isStickyHeader={true}>
                <TableHead>
                    <TableRow >
                        {columns.map((column) => (
                            <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={column.id} sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                                {column.label}
                                {column.id === 'poStatus' && (
                                    <div style={{ marginTop: -33, marginLeft: 100, height: 35 }} >
                                        <IconButton aria-haspopup="true" onClick={handleMenuOpen}>
                                            <ArrowDropDown />
                                        </IconButton>
                                    </div>
                                )}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(reqData?.poArr || []).map((i) => {
                        return (
                            <React.Fragment key={i?.id}>
                                <TableRow hover tabIndex={-1} onClick={() => handleRowClick(i?.poIdStrg)}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, height: 50, cursor: 'pointer' }} >
                                    {columns.map((column) => {
                                        const value = i[column.id];
                                        const { bycolor } = getPoStatusClrSx(value);
                                        switch (column.id) {
                                            case "orderCfmTime":
                                            case "expecDelDate":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    {formatDateWithJs(value)}
                                                </TableCell>
                                            case "totalPriceWithTax":
                                                return <TableCell key={column.id} align={column.align} >
                                                    {NumberFormatter(value)}
                                                </TableCell>
                                            case "poStatus":
                                                return <TableCell key={column.id} align={column.align} sx={{
                                                    textAlign: column.align,
                                                    justifyContent: "center", fontSize: 13
                                                }}>
                                                    <Box sx={{ bgcolor: bycolor, borderRadius: 16, py: 0.5 }}>
                                                        {formatUserType(value)}
                                                    </Box>

                                                </TableCell>
                                            default:
                                                return (
                                                    <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        {(value === null || value === "" || value === "null") ? "-" : value}
                                                    </TableCell>
                                                );
                                        }
                                    })}
                                </TableRow>
                            </React.Fragment>
                        );
                    })}
                </TableBody>
            </StyledTableContainer>}
            <Stack sx={{ alignItems: "center", mt: 2 }}>
                <Pagination count={Math.ceil(reqData?.totalRowsCount / limit) || 0} color="primary" page={pgNo} onChange={handlePageChange}
                    variant="outlined" shape="rounded" />
            </Stack>
            <DDMenu open={open} handleClose={handleMenuClose} anchorEl={anchorEl} >
                <MenuItem onClick={() => handleStatusSelect("")}> All</MenuItem>
                {statusArr.map((i) => <MenuItem onClick={() => handleStatusSelect(i.value)} key={i.label}>
                    {i.label}
                </MenuItem>)}
            </DDMenu>
        </Box>
    );
}

export default StorePoListPage